import React from 'react';

function TermsConditions() {
  return (
    <>
      <p className='fs-6'>
        The following terms and conditions apply and govern your use of BBE
        and related services including this website, your use of this site will
        establish your agreement, on behalf of yourself and the entity you
        represent (“you” or “your” or “Customer”), to all of the terms and
        conditions provided below.
      </p>

      <h1 className='fs-4 fw-bold ubbe-blue pb-2'>Service Description</h1>

      <p>
        BBE’s self-serve portal is a shipping service provided by BBE Expediting Ltd. (the{' '}
        <span className='fw-bold'>“Service Provider”</span>). The Service
        Provider agrees to provide delivery services as requested by the
        Customer. The Customer will provide instruction on the method of
        delivery of the Cargo and the delivery agent, and the Service Provider
        shall be responsible to provide the service requested and engage third
        party delivery agents to pick-up and deliver product to their
        destinations in accordance with the Customer’s instructions.
      </p>

      <h1 className='fs-6 fw-bold pb-2'>Ground Service</h1>
      <p className='fs-6'>
        Ground service delivery agents, costs and service level will be selected
        by the Customer during the order process. The provision of ground
        service by the Service Provider shall be governed by the Canadian
        International Freight Forwarding Association’s (“CIFFA”) Standard
        Trading Conditions, in addition to the within terms and conditions. In
        the provision of ground service, the Service Provider will be
        responsible for entering into an agreement directly with the delivery
        agents to arranging transportation, procurement and/or provide related
        services, such as, but not limited to, packaging, warehousing and any
        other kind of logistics services. See link below to the CIFFA Standard
        Trading Conditions (as amended from time to time) applicable herein:
        <br />
        <a
          href='https://ciffa.com/wp-content/uploads/2021/06/CIFFA-STCs-2021-English_Rebrand.pdf'
          target='_blank'
          rel='noopener noreferrer'
        >
          Ciffa Standard Trading Conditions
        </a>
      </p>

      <h1 className='fs-6 fw-bold pb-2'>Air Cargo Service</h1>
      <p className='fs-6'>
        Air cargo service delivery agents, costs and service level will be
        selected by the Customer during the order process. The provision of air
        cargo service by the Service Provider shall be governed by the
        applicable air cargo service delivery agent’s air cargo tariffs, in
        addition to the within terms and conditions. See links below to air
        cargo delivery agents cargo tariffs:
        <br />
        <a
          rel='noopener noreferrer'
          href='https://canadiannorth.com/wp-content/uploads/2021/09/Canadian-North-Domestic-Cargo-Tariff-CTAA-No-3-Original-08-Sep-2021.pdf'
          target='_blank'
        >
          Domestic Cargo Tariff
        </a>
        <br />
        <a
          rel='noopener noreferrer'
          href='https://www.westjet.com/assets/wj-web/documents/en/about-us/legal/cargo-tariff.pdf'
          target='_blank'
        >
          Westjet Cargo Tariff
        </a>
        <br />
      </p>

      <h1 className='fs-6 fw-bold pb-2'>Marine Service</h1>
      <p className='fs-6'>
        Marine service delivery agents, costs and service level will be selected
        by the Customer during the order process. The provision of marine
        service by the Service Provider shall be governed by the applicable
        marine service delivery agent’s marine service tariffs, in addition to
        the within terms and conditions. See links below for marine cargo
        delivery agents cargo tariffs:
        <br />
        <a
          rel='noopener noreferrer'
          href='https://www.arcticsealift.com/subsections/987/nunavut-ratesterms-and-general-conditions-transport.html'
          target='_blank'
        >
          NUNAVUT: PRICING, TERMS AND GENERAL CONDITIONS OF CARRIAGE
        </a>
        <br />
        <a
          rel='noopener noreferrer'
          href='https://www.arcticsealift.com/subsections/1052/nunavik-rates-terms-and-general-conditions-transport.html'
          target='_blank'
        >
          NUNAVIK RATES, TERMS AND GENERAL CONDITIONS OF TRANSPORT.
        </a>
        <br />
        <a
          rel='noopener noreferrer'
          href='https://neas.ca/wp-content/uploads/NEAS-Marine-Transport-Contract.pdf'
          target='_blank'
        >
          NEAS TERMS AND CONDITIONS
        </a>
        <br />
      </p>
    </>
  );
}

export default TermsConditions;
